import axios from 'axios'
import {AuthModel, UserModel} from './_models'
import {API_URL} from 'src/app/helpers/connection/API'

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/user-service/current-user`
export const LOGIN_URL = `${API_URL}/auth/authenticate`
export const REFRESH_TOKEN_URL = `${API_URL}/auth/refresh-token`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
export const PASSWORD_RESET_REQUEST_URL = `${API_URL}/user-password-reset/request`
export const PASSWORD_RESET_UPDATE_URL = `${API_URL}/user-password-reset/update`
export const PASSWORD_RESET_VERIFY_URL = `${API_URL}/user-password-reset/verify`

// Server should return AuthModel
export function login(username: string, password: string) {
  //axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
  return axios.post<AuthModel>(LOGIN_URL, {username,password})
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {

  return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL
  ,{
  headers: {
    'Authorization': `Basic ${token}`
  }
  }
  )
}

export function refreshToken() {
  return axios.post<AuthModel>(REFRESH_TOKEN_URL)
}

export async function postAuthLogout(){
  try{
    const resp = await axios.post(`${API_URL}/auth/logout`, {})
    console.log(resp)
    if (resp){
      return resp
    }

  } catch(error: any){
    throw error

  }

}

export async function requestPasswordReset(userName: string) {
  try {
    const resp = await axios.post(PASSWORD_RESET_REQUEST_URL, {
      userName,
      resetType: 'FORGOT_PASSWORD'
    })
    return resp.data
  } catch (error: any) {
    throw error
  }
}

export async function updatePasswordReset(userName: string, newPassword: string, resetToken: string) {
  try {
    const resp = await axios.post(PASSWORD_RESET_UPDATE_URL, {
      userName,
      newPassword,
      resetToken
    })
    return resp.data
  } catch (error: any) {
    throw error
  }
}

export async function verifyPasswordResetToken(resetToken: string) {
  try {
    const resp = await axios.post(PASSWORD_RESET_VERIFY_URL, {
      resetToken
    })
    return resp.data
  } catch (error: any) {
    throw error
  }
}